<script lang="ts" setup>
/**
 * UI-kit component
 * Category: Animations
 * Name: Animation particles
 * FIGMA: —
 */
import type { AnimationParticlesProps } from './interfaces'

import { ANIMATION_PARTICLES_DEFAULTS } from './animation-particles.config'
import { useAnimationParticles } from './use-animation-particles.hook'

defineOptions({
  name: 'AnimationParticles',
})

const props = withDefaults(defineProps<AnimationParticlesProps>(), {
  count: ANIMATION_PARTICLES_DEFAULTS.count,
  tabletCount: ANIMATION_PARTICLES_DEFAULTS.tabletCount,
  desktopCount: ANIMATION_PARTICLES_DEFAULTS.desktopCount,
  cleanupGap: ANIMATION_PARTICLES_DEFAULTS.cleanupGap,
  minSize: ANIMATION_PARTICLES_DEFAULTS.minSize,
  maxSize: ANIMATION_PARTICLES_DEFAULTS.maxSize,
})

const { particles, getParticleMotion } = useAnimationParticles({ props })
</script>

<template>
  <Teleport to="body">
    <div
      v-if="particles.length"
      class="animation-particles"
      aria-hidden="true"
    >
      <div
        v-for="particle in particles"
        :key="particle.id"
        v-motion="getParticleMotion(particle)"
        class="animation-particles__item"
        :style="{ left: `${particle.x}%` }"
      >
        <slot :particle="particle" />
      </div>
    </div>
  </Teleport>
</template>

<style lang="scss" scoped src="./_animation-particles.scss" />
